<template>
    <div class="wrapper">
        <div class="columns">
            <div class="column is-full">
                <div style="padding-top: 20px; width: 100%;">
                    <table class="table is-responsive is-fullwidth is-hoverable">
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Subject</th>
                            <th>Body</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="mail in mails" class="link">
                            <td class="date">{{ mail.date.date.replace('.000000', '') }}</td>
                            <td class="subject">{{ mail.subject }}</td>
                            <td class="body">{{ mail.body }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiGmail from './../../../../api/apiGmail'
    export default {
        props: ['user'],
        methods: {

        },
        data(){
            return {
                mails: [],
            }
        },
        created(){
            apiGmail
                .getAllMailFromUserRequest(this.$route.params.id)
                .then((response) => {
                    this.mails = response.data
                    console.log(response.data)
                })
                .catch(error => console.log(error))
        }
    }
</script>

<style scoped>
    .body {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display:block;
        max-width:900px;
        min-width:1px;
    }
    .date {
       width: 200px;
    }
    .subject {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width:100px;
        min-width:1px;
    }
    .link:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/UserMessages.vue